import React from 'react';
import { useIntl } from 'umi';

const Result = ({ type = '', value = [] }: any) => {
  const { formatMessage } = useIntl();
  const prefix = type?.slice?.(0, 1)?.toUpperCase?.();

  return (
    <div className="range-day-month-selector-result">
      <span className="range-day-month-selector-result-value">
        <span className="text-desc">
          {formatMessage({ id: 'Release Time' })}
        </span>
        {prefix}
        {value[0]} <i>~</i> {prefix}
        {value[1]}
      </span>
    </div>
  );
};

export default Result;
